import { render, staticRenderFns } from "./AssetCategoryConfig.vue?vue&type=template&id=231f3d9d&"
import script from "./AssetCategoryConfig.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports